import angular from 'angular'
import template from '../components/template.html'

angular.module('nominas.fondoreserva')
  .config(Config);

function Config($stateProvider) {
  $stateProvider.state('nominas.fondoReserva', {
    resolve: {
      nominas: ['NominasFondoReservaNominas', '$stateParams', function (NominasFondoReservaNominas, $stateParams) {
        if ($stateParams.idEmpresa)
          return NominasFondoReservaNominas.get($stateParams.idEmpresa)
            .then(function (response) {
              return response.data;
            });
      }],
      empresas: ['$catalogos', function ($catalogos) {
        return $catalogos.get('empresas');
      }],
      nominasFondoReserva: ['NominasFondoReservaNominasNomina', '$stateParams', function (NominasFondoReservaNominasNomina, $stateParams) {
        let id_proyecto = $stateParams.idEmpresa,
          id_nomina = $stateParams.idNomina;

        if (id_proyecto && id_nomina)
          return NominasFondoReservaNominasNomina.get(id_proyecto, id_nomina)
            .then(function (response) {
              return response.data;
            });
      }],
      catalogos: ['nominas', 'empresas', 'nominasFondoReserva', function (nominas, empresas, nominasFondoReserva) {
        return {
          Empresas: empresas,
          Nominas: nominas,
          Status: [
            {ID: '', Descripcion: 'Todos'},
            {ID: true, Descripcion: 'Activos'},
            {ID: false, Descripcion: 'Inactivos'},
          ],
          Salas: nominasFondoReserva ? ([{ID: '', Descripcion: 'Todas'}])
            .concat(nominasFondoReserva.Registros.map(function (item) {
                return item['Sala'];
              }).reduce(function (prev, next) {
                if (prev.indexOf(next) < 0)
                  prev.push(next);
                return prev;
              }, []).map(function (item) {
                return {ID: item, Descripcion: item};
              }),
            ) : [],
        };
      }],
    },
    url: '/fondoReserva?:idEmpresa&:idNomina',
    data: {title: 'Fondo de Reserva'},
    controllerAs: '$ctrl',
    controller: NominasFondoreservaComponent,
    template: template,
  });
}

function NominasFondoreservaComponent(nominasFondoReserva, catalogos, $scope, $location, $stateParams, NominasFondoReserva, $state, $dialog, $filter) {
  let $ctrl = this;
  $ctrl.data = nominasFondoReserva;
  $ctrl.saving = false;
  $ctrl.exportar = exportar;
  $ctrl.guardar = guardar;
  $ctrl.filtrar = filtrar;
  $ctrl.catalogos = catalogos;

  $ctrl.options = {
    ID_Empresa: $stateParams.idEmpresa,
    ID_Nomina: $stateParams.idNomina,
    Fecha_movimiento: $ctrl.data ? $ctrl.data.Fecha_Final : undefined,
  };

  $ctrl.filtros = {
    texto: '',
    status: '',
    sala: '',
    retencion: false,
  };

  function guardar() {
    $ctrl.saving = true;
    let data = {
      Fecha_Movimiento: $ctrl.data['Fecha_Final'].toYMD(),
      Notas: '#RF #' + $ctrl.data['Fecha_Final'].toYMD().replace(/-/g, ''),
      Servicios: $ctrl.data.Registros.filter(function (item) {
        return item['Fondo_Reserva_Retencion'] > 0;
      }).map(function (item) {
        return {
          ID_Empleado: item['ID_Empleado'],
          ID_Empresa: item['ID_Empresa'],
          Importe: item['Fondo_Reserva_Retencion'],
        };
      }),
    };

    return NominasFondoReserva.post(data).then(function () {
      $state.reload();
    });
  }

  function filtrar() {
    if (!$ctrl.data)
      return;
    let resultados = $ctrl.data.Registros
      .filter(function (item) {
        return ($ctrl.filtros.status !== '' ? item.Status === $ctrl.filtros.status : true)
          && ($ctrl.filtros.sala !== '' ? item.Sala === $ctrl.filtros.sala : true)
          && ($ctrl.filtros.retencion ? item['Fondo_Reserva_Retencion'] > 0 : true);
      });

    $ctrl.resultados = $filter('filter')(resultados, $ctrl.filtros.texto);
  }

  function exportar() {
    $dialog.show('nominas.fondoReserva.export', {data: $ctrl.data});
  }

  $scope.$watchGroup(['$ctrl.options.ID_Empresa', '$ctrl.options.ID_Nomina'], function () {
    $location.search({
      idEmpresa: $ctrl.options.ID_Empresa,
      idNomina: $ctrl.options.ID_Nomina,
    });
  });

  filtrar();
}



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/routes/nominas-fondoreserva.js